import React from 'react';
import './MessageSkeleton.css';

const MessageSkeleton = ({ count = 6 }) => {
  // Generate varying widths for more realistic look
  const generateWidths = () => {
    return Array.from({ length: count }).map((_, i) => {
      const widths = [
        [60, 40],
        [80, 50, 30],
        [70, 60],
        [90, 40],
        [50, 70, 20],
        [75, 45],
      ];
      return widths[i % widths.length];
    });
  };

  const messageWidths = generateWidths();

  return (
    <div className="messages-skeleton">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className={`message-skeleton ${i % 2 === 0 ? 'own' : 'other'}`}
        >
          {i % 2 !== 0 && <div className="skeleton-avatar" />}
          <div className="skeleton-bubble">
            {messageWidths[i].map((width, j) => (
              <div
                key={j}
                className="skeleton-line"
                style={{ width: `${width}%` }}
              />
            ))}
          </div>
          {i % 2 === 0 && <div className="skeleton-avatar" />}
        </div>
      ))}
    </div>
  );
};

export default MessageSkeleton;
